import {graphql, useFragment} from 'react-relay'

import type {IssueOrPullRequestUnreadIndicator$key} from './__generated__/IssueOrPullRequestUnreadIndicator.graphql'
import type {IssueRowSecondaryQuery$data} from './__generated__/IssueRowSecondaryQuery.graphql'
import {UnreadIndicator} from './UnreadIndicator'

// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
const notificationFragment = graphql`
  fragment IssueOrPullRequestUnreadIndicator on IssueOrPullRequest {
    __typename
    ... on Issue {
      isReadByViewer
    }
    ... on PullRequest {
      isReadByViewer
    }
  }
`

type IssueOrPullRequestUnreadIndicatorProps = {
  issueId: string
  listItemMetadata?: IssueRowSecondaryQuery$data | null
}

export function IssueOrPullRequestUnreadIndicator({issueId, listItemMetadata}: IssueOrPullRequestUnreadIndicatorProps) {
  if (!listItemMetadata) return null

  const issueNode = listItemMetadata.nodes?.find(node => node?.id === issueId)

  if (!issueNode) return null

  const notificationKey =
    issueNode.__typename === 'Issue'
      ? issueNode.issueUnreadIndicator
      : issueNode.__typename === 'PullRequest'
        ? issueNode.pullRequestUnreadIndicator
        : null

  if (!notificationKey) return null

  return <IssueOrPullRequestUnreadIndicatorInternal notificationKey={notificationKey} />
}

type IssueOrPullRequestUnreadIndicatorInternalProps = {
  notificationKey?: IssueOrPullRequestUnreadIndicator$key
}

function IssueOrPullRequestUnreadIndicatorInternal({notificationKey}: IssueOrPullRequestUnreadIndicatorInternalProps) {
  const data = useFragment(notificationFragment, notificationKey)

  const isReadByViewer = data && 'isReadByViewer' in data ? data.isReadByViewer : false

  return <UnreadIndicator unread={!isReadByViewer} />
}
